import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import { useForm } from "react-hook-form"
import { encodeStorage, removeStorage } from 'newFunctions/storageBase64'
import { postOtherCards } from 'services/Cards'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import useTokenNew from './useTokenNew';

import CurrencyFormat from "react-currency-format";
import { dateFormat } from 'newFunctions/dateFormat'
import { decodeStorage } from 'newFunctions/storageBase64'


export const usePagoExpress = () => {
    const history = useHistory()
    const {
        isValid
    } = useTokenNew({name: 'usePagoExpress'})
    
    const [datosBancarios, setDatosBancarios] = useState(false);
    const { register, handleSubmit, errors } = useForm({
        defaultValues: {
            numero: datosBancarios?.numero,
        }
    });

    const [loading, setLoading] = useState(false)
    const [showModalTarjetaInvalida, SetShowModalTarjetaInvalida] = useState(false);
    const [flagNumero, setFlagNumero] = useState(false);     // banderas para mostrar ayuda inputs
    const [datos, setDatos] = useState();
    const [returnForm, SetReturnForm] = useState(false);

    //- valores para agregar tarjeta
    const [inputNumberCard, setInputNumberCard] = useState();

    // ocultar modal
    const noRemove = () => {
        SetShowModalTarjetaInvalida(false);
    };

    // ocultar modal
    const siRemove = () => {
        SetShowModalTarjetaInvalida(false);
    };

    // cerrar modal de tarjeta Invalida
    const handleClose = () => SetShowModalTarjetaInvalida(false);

    // activar on focus
    const onFocusInputs = (e) => {
        let idFocus = e.target.id;

        if (idFocus === "numero") {
            setFlagNumero(true);
        }
    };

    // desactivar on focus
    const onBlurInputs = (e) => {
        let idFocus = e.target.id;

        if (idFocus === "numero") {
            setFlagNumero(false);
        }
    };

    // guarda la informacion enviada en el formulario
    const sendFormInformacionTarjeta = data => {
        setDatos({
            "cardnumber": data.numero
        });
        SetReturnForm(true);
    };

    // al recibir data del formulario se guarda en variable datos bancarios
    const [response, setResponse] = useState()
    useEffect(() => {
        if (returnForm) {
            if(isValid){
                setLoading(true)
                postOtherCards(datos)
                .then(setResponse)
            }
        }
    }, [returnForm]);
    
    removeStorage('pagoExpress')
    removeStorage('cardendingPayment')
    removeStorage('noInternetPayment')
    const [err500, setErr500] = useState()

    useEffect(()=>{
        if(response){
            if(response.statusCode === 200){
                //setDatosBancarios(datos);
                setLoading(false)
                if(response.data){
                    if(response.data[0]){
                        let pagoExpress = {
                            card: response.data[0]?.card_number,
                            cardending: response.data[0]?.card_number?.slice(-4),
                            account_number: response.data[0]?.account_number,
                            nombreTitular: response.data[0]?.name+' '+response.data[0]?.paternal+' '+response.data[0]?.maternal,
                            monthly_payment: response.data[0]?.monthly_payment,
                            minimum_to_pay: response.data[0]?.minimum_to_pay,
                            new_balance_cutting: response.data[0]?.new_balance_cutting,
                            payment_not_generate_interest: response.data[0]?.payment_not_generate_interest,
                            payday_limit: response.data[0]?.payday_limit,
                            credit_available: response.data[0]?.credit_available,
                            credit_imit: response.data[0]?.credit_imit,
                            no_internet: response.data[0]?.no_internet
                        }
                        encodeStorage('pagoExpress', pagoExpress)

                        if(response.data[0]?.no_internet){
                            encodeStorage('noInternetPayment', response.data[0]?.no_internet)
                        }
                        history.push(`${BASE_PATH}${SUB_DIRECTORY}informacion-tarjeta-express`);
                        SetReturnForm(false);
                    }
                }

            }
            else if(response.statusCode >= 500){
                setErr500(response.statusCode)
                setLoading(false)
            }
            else{
                setLoading(false)
                setInputNumberCard('')
                SetReturnForm(false)
                SetShowModalTarjetaInvalida(true);
                removeStorage('pagoExpress')
                removeStorage('cardendingPayment')
                removeStorage('noInternetPayment')
            }
        }
    },[response])

    // validaciones
    const valNumero = {
        required: 'Campo obligatorio',
        minLength: {
            value: 12,
            message: 'Faltan dígitos. Deben ser al menos 12 dígitos'
        },
        maxLength: {
            value: 13,
            message: 'No debe contener más de 13 dígitos'
        },
        pattern: {
            value: /[0-9]{12,13}/,
            message: 'El formato de la tarjeta es inválido'
        }
    }
    
    
    return{
        inputNumberCard,
        valNumero,
        showModalTarjetaInvalida,
        loading,
        errors,
        err500,
        handleSubmit,
        register,
        sendFormInformacionTarjeta,
        setInputNumberCard,
        handleClose,
        siRemove,
        noRemove
    }
}


export const usePagoExpressResumen = () => {
    const history = useHistory();
    const pagoExpress = decodeStorage('pagoExpress')

    const [nombreTitular, setNombreTitular] = useState('Nombre del titular')
    const [numeroTarjeta, setNumeroTarjeta] = useState('**** **** ****')
    const [mensualidad, setMensualidad] = useState('0.00')
    const [minimo, setMinimo] = useState('0.00')
    const [saldoNuevoCorte, setSaldoNuevoCorte] = useState('0.00')
    const [pagoNoGenerarIntereses, setPagoNoGenerarIntereses] = useState('0.00')
    const [fechaLimite, setFechaLimite] = useState( dateFormat( '1210101') )
    const [monto, setMonto] = useState('0.00')
    const [limiteCredito, setLimiteCredito] = useState('0.00')

    useEffect(()=>{
        if(pagoExpress){
            setNombreTitular(pagoExpress.nombreTitular)
            setNumeroTarjeta("** **** *" + pagoExpress.cardending)
            setMensualidad(pagoExpress.monthly_payment)
            setMinimo(pagoExpress.minimum_to_pay)
            setSaldoNuevoCorte(pagoExpress.new_balance_cutting)
            setPagoNoGenerarIntereses(pagoExpress.payment_not_generate_interest)
            setFechaLimite( dateFormat( pagoExpress.payday_limit) )
            setMonto(pagoExpress.credit_available)
            setLimiteCredito(pagoExpress.credit_imit)
        }else{
            history.replace(`${BASE_PATH}${SUB_DIRECTORY}pago-express`);
        }
    },[pagoExpress])


    let montoMensualidad = <CurrencyFormat
        value={Number(mensualidad % 1) === 0 ? mensualidad + '.001' : mensualidad}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;

    let montoMinimo = <CurrencyFormat
        value={Number(minimo % 1) === 0 ? minimo + '.001' : minimo}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;

    let montoNuevoCorte = <CurrencyFormat
        value={Number(saldoNuevoCorte % 1) === 0 ? saldoNuevoCorte + '.001' : saldoNuevoCorte}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;

    let montoPagoNoGenerarIntereses = <CurrencyFormat
        value={Number(pagoNoGenerarIntereses % 1) === 0 ? pagoNoGenerarIntereses + '.001' : pagoNoGenerarIntereses}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={''} renderText={value => <>{value} </>} />;

    let saldoDisponible = <CurrencyFormat
        value={Number(monto % 1) === 0 ? monto + '.001' : monto}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;

    let montoLimiteCredito = <CurrencyFormat
        value={Number(limiteCredito % 1) === 0 ? limiteCredito + '.001' : limiteCredito}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;
    

    const handleContinuar = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar-tarjeta`);
    };

    return{
        numeroTarjeta,
        nombreTitular,
        montoMensualidad,
        montoMinimo,
        montoNuevoCorte,
        montoPagoNoGenerarIntereses,
        fechaLimite,
        saldoDisponible,
        montoLimiteCredito,
        handleContinuar
    }
}